var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 34.3C35.0359 34 33.6695 14.6333 48 13.7333V0C16.9061 0.966667 15.1065 46.2 48 48V34.3Z",
    fill: "#082C4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34.3C59.0359 34 57.6695 14.6333 72 13.7333V0C40.9061 0.966667 39.1065 46.2 72 48V34.3Z",
    fill: "#FE6571"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C-7.09385 47.0333 -8.89349 1.8 24 0L24 48Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceChart);
export default __webpack_public_path__ + "static/media/voice-chart.60a84ddac871afd4dfa29e2f70593ac2.svg";
export { ForwardRef as ReactComponent };